import { styled } from '@mui/material';

export const FiltersWrapper = styled('div')({
  width: '60%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  gap: 12,
});
